import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import "../../../styles/Form.css";
import Select from "react-select";
import SearchGoogleLandmark from "../../../components/commonComponent/SearchGoogleLandmark";
import { MODE } from "../../../constants/SiteConstants";
import { generateSlug } from "../../../utils/commonFunc";
import Switch from "../../../components/commonComponent/Switch";
import 'react-quill/dist/quill.snow.css';

const API_URL = process.env.REACT_APP_API_URL;

const VendorForm = ({
  fields = [],
  onSubmit,
  mode,
  initialData = {},
  handleImageChange,
  handleCustomerImageChange,
  imagePreviews = [],
  isGoogleMapLoaded = false,
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [landmark, setLandmark] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState({});
  const [slugMessage, setSlugMessage] = useState("");
  const [isSlugUnique, setIsSlugUnique] = useState(null);
  const [branches, setBranches] = useState(mode === MODE.UPDATE ? initialData.branches : [{ phone: "", location: [] }]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState({});
  const [selectedState, setSelectedState] = useState(null);
  const [showHtml, setShowHtml] = useState(false);
  console.log(formData, "formDataformData");
  console.log(stateOptions, "stateOptionsstateOptionsstateOptions");
  
  useEffect(() => {
    const fetchOptions = async () => {
      for (const field of fields) {
        if (field.isMultifield) {
          if (field.name === "state") {
            await fetchStateOptions();
          } else if (field.name === "city" && selectedState) {
            await fetchCityOptions(selectedState);
          }
        }
      }
    };

    fetchOptions();
  }, [fields, selectedState]);

  const fetchStateOptions = async () => {
    try {
      const response = await axios.get(`${API_URL}/stateWithCities/getAllStates`);
      const options = response.data.map((state) => ({
        value: state._id,
        label: state.name,
      }));
      setStateOptions(options);
    } catch (error) {
      console.error("Error fetching state options:", error);
    }
  };

  const fetchCityOptions = async (stateId) => {
    try {
      const response = await axios.get(
        `${API_URL}/stateWithCities/getCitiesByState/${stateId}`
      );
      const options = response.data.map((city) => ({
        value: city._id,
        label: city.name,
      }));
      setCityOptions((prev) => ({ ...prev, [stateId]: options }));
    } catch (error) {
      console.error("Error fetching city options:", error);
    }
  };

  const handleStateChange = (selectedState) => {
    setSelectedState(selectedState ? selectedState.value : null);
    setFormData((prevData) => ({
      ...prevData,
      state: selectedState ? selectedState.label : "", // Store state name
    }));
  };

  const handleCityChange = (selectedCity) => {
    setFormData((prevData) => ({
      ...prevData,
      city: selectedCity ? selectedCity.label : "", // Store only the city name as a string
    }));
  };

// ...existing code...
useEffect(() => {
  if (mode === MODE.UPDATE && initialData) {
    setFormData(initialData);

    // Find the state option that matches the initialData.state
    if (initialData.state && stateOptions.length > 0) {
      const foundState = stateOptions.find(
        (option) => option.label === initialData.state || option.value === initialData.state
      );
      if (foundState) {
        setSelectedState(foundState.value);
        // Fetch cities for this state
        fetchCityOptions(foundState.value).then(() => {
          // After fetching, set the city if available
          if (initialData.city) {
            setFormData((prev) => ({
              ...prev,
              city: initialData.city,
            }));
          }
        });
      }
    }
  }
}, [initialData, mode, stateOptions]);
// ...existing code...

  const handleStatusChange = (name, newStatus) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newStatus,  // Update the specific field with the new status (true/false)
    }));
  };
  const handleBranchStateChange = async (index, selectedState) => {
    const updatedBranches = [...branches];
    updatedBranches[index].state = selectedState ? selectedState.label : ""; // Update branch state
    updatedBranches[index].city = ""; // Reset city since the state has changed

    // Fetch cities for the selected state
    if (selectedState) {
      try {
        const response = await axios.get(
          `${API_URL}/stateWithCities/getCitiesByState/${selectedState.value}`
        );
        const options = response.data.map((city) => ({
          value: city._id,
          label: city.name,
        }));

        // Update branch-specific city options
        setCityOptions((prev) => ({
          ...prev,
          [index]: options, // Store city options for this branch
        }));
      } catch (error) {
        console.error("Error fetching city options:", error);
      }
    }

    setBranches(updatedBranches);
  };

  const handleBranchCityChange = (index, selectedCity) => {
    const updatedBranches = [...branches];
    updatedBranches[index].city = selectedCity ? selectedCity.label : ""; // Update branch city
    setBranches(updatedBranches);
  };


  const addBranch = () => {
    setBranches([
      ...branches,
      { name: "", location: "", phone: "", branchAddress: "", city: "", state: "" },
    ]);
  };

  const handleBranchChange = (index, name, value) => {
    const updatedBranches = [...branches];
    updatedBranches[index][name] = value;
    setBranches(updatedBranches);
  };

  const handleBranchLandmarkChange = (index, location) => {
    const updatedBranches = [...branches];
    updatedBranches[index].location = location;
    setBranches(updatedBranches);
  };

  // Fetch service options
  const fetchServiceOptions = async () => {
    try {
      const response = await axios.get(`${API_URL}/services/getAllServices`);
      const options = response.data.data.flatMap((service) =>
        service.options.map((option) => ({
          value: option,
          label: option,
        }))
      );
      setServiceOptions(options);
    } catch (error) { }
  };

  // Fetch category options based on field name
  const fetchCategoryOptions = async (fieldName) => {
    try {
      let response;
      if (fieldName === "blogcategory") {
        response = await axios.get(
          `${API_URL}/blogcategory/getAllblogcategory`
        );
      } else if (fieldName === "productcategory") {
        response = await axios.get(
          `${API_URL}/productcategory/getAllproductcategories`
        );
      } else if (fieldName === "Tags") {
        response = await axios.get(`${API_URL}/services/getAllServices`);
      }
      if (response?.data?.data) {
        const options = response.data.data.map((category) => ({
          value: category.name,
          label: category.name,
        }));

        setCategoryOptions((prevOptions) => ({
          ...prevOptions,
          [fieldName]: options,
        }));
      }
    } catch (error) { }
  };

  useEffect(() => {
    fields.forEach((field) => {
      if (field.isMultifield) {
        fetchCategoryOptions(field.name);
      } else if (field.isTagsMultifield) {
        fetchServiceOptions();
      }
    });
  }, [fields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Auto-generate slug if field is title or name
    if (name === "title" || name === "name") {
      const slug = generateSlug(value);
      setFormData((prevData) => ({
        ...prevData,
        slug,
      }));
      checkSlugUniqueness(slug); // Check slug uniqueness when it is generated
    }

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  // Function to check slug uniqueness
  const checkSlugUniqueness = async (slug) => {
    try {
      const response = await axios.get(`${API_URL}/vendor/vendorListing`, {
        params: { slug }, // Adjust the query parameter based on your API's requirements
      });

      const existingSlugs = response.data.map((vendor) => vendor.slug); // Adjust this based on your response structure

      if (existingSlugs.includes(slug)) {
        setIsSlugUnique(false);
        setSlugMessage("Slug is not unique, please choose another."); // Set error message
      } else {
        setIsSlugUnique(true);
        setSlugMessage("Slug is available!"); // Set success message
      }
    } catch (error) {
      console.error("Error checking slug uniqueness", error);
      setIsSlugUnique(null); // Reset state in case of error
    }
  };

  const handleQuillChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  const handleTagsChange = (selectedOptions, fieldName) => {
    const tags = selectedOptions.map((option) => option.value);
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: tags,
    }));
  };

  const validateForm = () => {
    const formErrors = {};

    fields.forEach((field) => {
      const value = formData[field.name];
      console.log("valuevaluevalue ", value);
      // if (field.required && !value) {
      //   formErrors[field.name] = `${field.label} is required`;
      // }

      if (field.name === "description" && value) {
        const strippedValue = value.replace(/<[^>]+>/g, "").trim();
        if (!strippedValue) {
          formErrors[field.name] = "Description is required";
        }
      }

      // if (field.name === "phone" && value) {
      //   const phoneRegex = /^[0-9]{10}$/;
      //   if (!phoneRegex.test(value)) {
      //     formErrors[field.name] = `${field.label} must be a valid 10 digits number`;
      //   }
      // }
    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm() && isSlugUnique !== false) {
      const updatedFormData = {
        ...formData,
        branches: branches.map((branch) => ({
          name: branch.name,
          location: branch.location,
          phone: branch.phone,
          branchAddress: branch.branchAddress,
          city: branch.city,
          state: branch.state,
        })),
      };

      onSubmit(updatedFormData);
    }
  };
  const modules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
      [{ 'size': ['small', 'medium', 'large', 'huge'] }],
      [{ 'align': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image', 'video'],
      [{ 'color': [] }, { 'background': [] }],
      ['code-block'],
    ],
  };



  return (
    <form onSubmit={handleSubmit}>
      {fields.map((field) => (
        <div className="mb-4" key={field.name}>
          <label
            htmlFor={field.name}
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            {field.label}
          </label>
          {field.type === "file" ? (
            <>
              <input
                type="file"
                name={field.name}
                onChange={(e) => {
                  if (field.name === "image") {
                    handleImageChange(e);
                  } else {
                    handleCustomerImageChange(e);
                  }
                }}
              />
              {field.name === "image" && imagePreviews.length > 0 && (
                <div className="image-previews w-full rounded-md border border-stroke p-3 outline-none file:mr-4 file:rounded file:border-[0.5px] file:border-stroke file:bg-[#EEEEEE] file:py-1 file:px-2.5 file:text-sm">
                  {imagePreviews.map((preview, index) => (
                    <img
                      key={index}
                      src={preview}
                      alt="preview"
                      width={50}
                      height={50}
                    />
                  ))}
                </div>
              )}
            </>
          ) : field.type === "rich-text" ? (
            <div className="mt-4">
              <div className="flex justify-end mb-2">
                <button
                  type="button"
                  onClick={() => setShowHtml(!showHtml)}
                  className="text-sm text-blue-600 hover:underline"
                >
                  {showHtml ? 'Switch to Editor' : 'View HTML'}
                </button>

              </div>

              {showHtml ? (
                <textarea
                  value={formData[field.name] || ""}
                  onChange={(e) => handleQuillChange(field.name, e.target.value)}
                  className="w-full h-64 p-2 border border-gray-300 rounded font-mono text-sm"
                />
              ) : (
                <ReactQuill
                  value={formData[field.name] || ""}
                  onChange={(value) => handleQuillChange(field.name, value)}
                  placeholder={field.placeholder}
                  className="mt-2"
                  modules={modules}
                />
              )}
            </div>
          ) :
            field.isMultifield ? (
              <div key={field.name} className="form-group">
                <label>{field.label}</label>
                {field.name === "state" ? (
              <Select
    isMulti={false}
    options={stateOptions}
    onChange={handleStateChange}
    placeholder={field.placeholder}
    className="mt-2"
    value={
      stateOptions.find(
        (option) =>
          option.label === formData.state ||
          option.value === selectedState
      ) || null
    }
  />
                ) : field.name === "city" ? (
                  
                 <Select
    isMulti={false}
    options={cityOptions[selectedState] || []}
    onChange={handleCityChange}
    placeholder={field.placeholder}
    className="mt-2"
    isDisabled={!selectedState}
    value={
      (cityOptions[selectedState] || []).find(
        (option) =>
          option.label === formData.city ||
          option.value === formData.city
      ) || null
    }
  />
                ) : null}
              </div>

            ) :
              field.type === "checkbox" ? (
                <div className="mt-7">
                  <input
                    type="checkbox"
                    checked={formData[field.name] || false}
                    onChange={(e) => handleStatusChange(field.name, e.target.checked)}
                    id={field.name}
                    className="form-checkbox h-5 w-5 text-primary"
                  />

                </div>
              ) : (
                <input
                  type={field.type}
                  name={field.name}
                  value={formData[field.name] || ""}
                  onChange={handleChange}
                  placeholder={field.placeholder}
                  className="mt-2 border rounded-md px-3 py-2 w-full"
                />
              )}

          {field.name === "slug" && slugMessage && (
            <div
              className={`mt-1 text-sm ${isSlugUnique ? "text-green-600" : "text-red-600"
                }`}
            >
              {slugMessage}
            </div>
          )}
          {errors[field.name] && (
            <div className="mt-1 text-red-600">{errors[field.name]}</div>
          )}
        </div>
      ))}

      {branches.map((branch, index) => (
        <div key={index} className="mt-4">
          <h4 className="text-md font-semibold">Branch {index + 1}</h4>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Phone
            </label>
            <input
              type="text"
              value={branch.phone}
              onChange={(e) =>
                handleBranchChange(index, "phone", e.target.value)
              }
              placeholder="Enter branch phone number"
              className="mt-2 border rounded-md px-3 py-2 w-full"
            />
            <label className="block text-sm font-medium text-gray-700 mb-2">
              branchAddress
            </label>
            <input
              type="text"
              value={branch.branchAddress}
              onChange={(e) =>
                handleBranchChange(index, "branchAddress", e.target.value)
              }
              placeholder="Enter branchAddress "
              className="mt-2 border rounded-md px-3 py-2 w-full"
            />
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                State
              </label>
              <Select
                isMulti={false}
                options={stateOptions}
                onChange={(selectedOption) => handleBranchStateChange(index, selectedOption)}
                placeholder="Select state"
                className="mt-2"
                value={
                  branch.state
                    ? { value: branch.state, label: branch.state }
                    : null
                }
              />
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                City
              </label>
              <Select
                isMulti={false}
                options={cityOptions[index] || []} // Use branch-specific city options
                onChange={(selectedOption) => handleBranchCityChange(index, selectedOption)}
                placeholder="Select city"
                className="mt-2"
                value={
                  branch.city
                    ? { value: branch.city, label: branch.city }
                    : null
                }
                isDisabled={!branch.state} // Disable if no state is selected
              />
            </div>

          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Location
            </label>
            {isGoogleMapLoaded && (
              <SearchGoogleLandmark
                setLandmark={(location) =>
                  handleBranchLandmarkChange(index, location)
                }
                title="Branch Location"
                location={branch.location}
              />
            )}
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={addBranch}
        className="mt-2 bg-blue-500 text-white py-2 px-4 rounded-md"
      >
        Add More Branches
      </button>

      <button
        type="submit"
        className="mt-4 w-full rounded-lg bg-[#1C2434] text-white py-3 hover:bg-[#1C2434]"
      >
        Submit
      </button>
    </form>
  );
};

export default VendorForm;
